import { useProjectsStore } from "@nextories/vue-tasks/src/store/projectsStore";

export const pluginEstimateStore = {
  state: {
    deleteVeryLowEstimate: false,
  },
  actions: {
    useRootStore: function () {
      return useProjectsStore();
    },
    useFieldsStore: function () {
      return useProjectsStore();
    },
    setDataSaving: function (value?: boolean) {
      this.useRootStore().setDataSaving(value);
    },
    setSavedApiResponse: function (item: {}) {
      this.useRootStore().setSavedApiResponse(item);
    },
  },
};
